export enum BoxStatus {
  UNKNOWNBOXSTATUS = 'UNKNOWN_BOX_STATUS',
  RUNNING = 'RUNNING',
  IN_MAINTENANCE = 'IN_MAINTENANCE',
  IN_PREPARING = 'PREPARING'
}
